// stores/helperStore.js
import { makeAutoObservable } from 'mobx'
import logger from '../utils/logger'
import { registerTenantScopedReset } from '../tenancy/tenantScopedState'

class HelperStore {
	filesMbx = []

	constructor() {
		makeAutoObservable(this)
	}

	setFilesMbx(fileGroup) {
		logger.log('👓 fileGroup:', fileGroup.type)

		const existingIndex = this.filesMbx.findIndex(
			item => item.type === fileGroup.type
		)

		if (existingIndex >= 0) {
			// Обновляем существующий объект
			this.filesMbx[existingIndex] = fileGroup
		} else {
			// Добавляем новый объект
			this.filesMbx.push(fileGroup)
		}
	}

	getFilesMbx() {
		return this.filesMbx
	}

	clearOrganizationState() {
		this.filesMbx = []
	}
}

const helperStore = new HelperStore()
registerTenantScopedReset('upload-drafts', () => helperStore.clearOrganizationState())
export default helperStore
